import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//MUI
import { Typography, Button } from "@mui/material";

//Icons
import { ReactComponent as CartIcon } from "../../../../../assets/icons/svg/shopping-cart.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

//Actions
import { openEditExpenseModal } from "../../../../../actions/pantry";

//Modal
import CustomModal from "../../../../modal/CustomModal";
export const ItemPurchaseInfo = ({ item: { loading, error, data }, modal: { open } }) => {
  return (
    <div className="p-4 rounded-lg border border-separator w-full">
      <div className="flex flex-row items-center gap-2">
        <CartIcon className="h-4" />
        <Typography variant="subtitle1">Purchase Info</Typography>
      </div>
      <div>
        <Typography variant="subtitle1" className="font-normal mt-6">
          <span className="font-medium">Safeway</span>
          <span> on </span>
          <span className="text-mainGreen italic">Jan 24, 2025</span>
        </Typography>
      </div>
      <Button className="p-0 hover:bg-transparent text-start" disableRipple>
        <div className="w-full flex flex-col">
          <div className="mt-2">
            <Typography variant="h5" className="text-mainGreen font-semibold">
              $5.47
            </Typography>
          </div>
          <div className="flex flex-row items-center">
            <FontAwesomeIcon icon={faChevronUp} className="mr-1" />
            <Typography variant="subtitle2" className="font-normal">
              $0.15 (+2.8%) <span className="text-secondaryText italic">from last purchase</span>
            </Typography>
          </div>
        </div>
      </Button>
    </div>
  );
};

ItemPurchaseInfo.propTypes = {
  item: PropTypes.object.isRequired,
  modal: PropTypes.object.isRequired,
  openEditItemExpenseModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  item: state.pantry.item,
  modal: state.pantry.modals.editItemExpense,
});

export default connect(mapStateToProps)(ItemPurchaseInfo);
